module.exports = __webpack_public_path__ + "img/Glo_button1.7c0d578d.png";